/* tslint:disable */
/* eslint-disable */
export const SESSION_STORAGE_KEY = 'session';
export const CLIENT_IP_HEADER_KEY = 'x-ctv-realip';
export const CLOUDFRONT_IP_HEADER_KEY = 'cloudfront-viewer-address';

export enum TrackingEventsConstants {
  SV_CLICK_EVENT = 'svClickEvent',
}

export const MAX_POLLING_DURATION = 5000;

export const SITE_CONNECT_FROM_TRACKER = 'Site Connect: End of study ad';
